<form [formGroup]="auth_signup_form_group">
  <mat-form-field
    class="hmn-width__full hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.EMAIL_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="email"
      formControlName="email"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="hmn-width__full hmn-form-field__primary"
    [ngClass]="getPssFormFieldErrorClass(false)"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'AUTH.PASSWORD_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      [type]="is_password_visible ? 'text' : 'password'"
      formControlName="password"
      [errorStateMatcher]="error_matcher"
      required />
    <mat-icon
      matSuffix
      class="sp-color__accent-contrast sp-cursor__pointer"
      (click)="is_password_visible = !is_password_visible">
      {{ is_password_visible ? 'visibility_off' : 'visibility' }}
    </mat-icon>
    <mat-error *ngIf="hasPssLengthError(false)">
      {{ 'ERROR.PASSWORD_LENGTH' | translate }}
    </mat-error>
    <mat-error *ngIf="hasPssPatternError(false)">
      {{ 'ERROR.PASSWORD_PATTERN' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field
    class="hmn-width__full hmn-form-field__primary"
    [ngClass]="getPssFormFieldErrorClass(true)"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'AUTH.PASSWORD_CONFIRM_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      [type]="is_password_visible ? 'text' : 'password'"
      formControlName="password_confirm"
      [errorStateMatcher]="error_matcher"
      required />
    <mat-icon
      matSuffix
      class="sp-color__primary sp-cursor__pointer"
      (click)="is_password_visible = !is_password_visible">
      {{ is_password_visible ? 'visibility_off' : 'visibility' }}
    </mat-icon>
    <mat-error *ngIf="hasPssLengthError(true)">
      {{ 'ERROR.PASSWORD_LENGTH' | translate }}
    </mat-error>
    <mat-error *ngIf="hasPssPatternError(true)">
      {{ 'ERROR.PASSWORD_PATTERN' | translate }}
    </mat-error>
  </mat-form-field>

  <app-shared-button
    class="hmn-margin__x6-top hmn-display__block"
    [button_cta]="'AUTH.SIGNUP_CTA'"
    [button_class]="'hmn-button__main hmn-width__full'"
    [button_cta_class]="'hmn-text__5'"
    (button_click)="onSignupClick()"></app-shared-button>

  <app-shared-button
    class="hmn-margin__x4-top hmn-display__block"
    [button_cta]="'AUTH.SIGNIN_REDIRECT_CTA'"
    [button_class]="'hmn-button__secondary-accent hmn-width__full'"
    [button_cta_class]="'hmn-text__5'"
    (button_click)="onSigninRedirectClick()"></app-shared-button>
</form>
